import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { context } from "../.."
import React from "react"
import { observer } from "mobx-react-lite"
import { IFieldProps } from "../../interfaces"

export default observer(function FieldSelect ({formik, field, autoFocus = false}: IFieldProps) {

    const label = context.formatLabel(field.label)
    const options = field.setListKey ? context.getListSet(field.setListKey) : field.options
        
    return (
        <div className="form-field">
            <FormControl variant="standard">
                <InputLabel id={field.name}>{label}</InputLabel>

                <Select
                    labelId={field.name}
                    id={field.name}
                    name={field.name}
                    value={formik.values[field.name]}
                    autoFocus={autoFocus}
                    error={formik.submitCount ? !!formik.errors[field.name] : false}
                    onChange={formik.handleChange}>
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>

                        {Object.keys(options).map((value, i) => {
                            var label = context.formatLabel(options[value])
                            // Don't show options with placeholders remaining
                            if (label.includes("{") || label.includes("}")) {
                                return <React.Fragment key={i}></React.Fragment>
                            }
                            return <MenuItem key={i} value={value}>{label}</MenuItem>
                        })}
                </Select>
            </FormControl>

            {field.helpText ? (
                <span className="help-text" style={{marginTop: "4px"}}>{field.helpText}</span>
            ) : null}
        </div>
    )
})